import { Injectable } from '@angular/core';
import { ProgressDialogComponent } from './progress-dialog/progress-dialog.component';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';

@Injectable()
export class ProgressDialogService {

	private opened = false;
	private dialogRef: NxModalRef<ProgressDialogComponent> | null = null;

	constructor(private readonly dialogService: NxDialogService) {}

	openDialog(progressDetails: any): void {
		if (!this.opened) {
			this.opened = true;

			this.dialogRef = this.dialogService.open(ProgressDialogComponent, {
				data: progressDetails
			});

			this.dialogRef.afterClosed().subscribe(() => {
				this.opened = false;
				this.dialogRef = null;
			});
		}
	}

	setProgress(progress: number, processedCount: number, total: number, speed: number, eta: number) {
		if (this.dialogRef?.componentInstance) {
			const data = this.dialogRef.componentInstance.data;
			data.total = total;
			data.progress = progress;
			data.processed = processedCount;
			data.speed = Math.round(speed * 100) / 100;
			data.eta = eta;
		}
	}

	close(): void {
		this.dialogRef?.close();
		this.dialogRef = null;
		this.opened = false;
	}
}